import React, { memo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  flexRender,
} from '@tanstack/react-table'

const Table = (opts) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageIndexFromURL = parseInt(searchParams.get('page') || '0', 10); 

  const table = useReactTable({
    ...opts,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageIndex: pageIndexFromURL, 
      },
    },
    debugTable: true,
  })

  const generatePageNumbers = () => {
    const totalPages = table.getPageCount();
    const pageIndex = table.getState().pagination.pageIndex;
    const visiblePageCount = 3;

    if (totalPages <= visiblePageCount) {
      // Return all page numbers if there are 3 or fewer pages
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pageNumbers = [];

    if (pageIndex === 0 || pageIndex === 1) {
      pageNumbers.push(1, 2, 3);
    } else if (pageIndex === totalPages - 1) {
      pageNumbers.push(totalPages - 2, totalPages - 1, totalPages);
    } else {
      pageNumbers.push(pageIndex, pageIndex + 1, pageIndex + 2);
    }

    return pageNumbers;
  };

  useEffect(() => {
    setSearchParams({ page: table.getState().pagination.pageIndex});
  }, [table.getState().pagination.pageIndex]);

  return (
    <div className="p-2 max-w-full">
      <div className="h-2"/>
      <table className="w-full">
        <thead>
        {table.getHeaderGroups().map(headerGroup => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => {
              return (
                <th key={header.id} colSpan={header.colSpan} style={{...header?.column?.columnDef?.meta?.style}}>
                  {header.isPlaceholder ? null : (
                    <div>
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </div>
                  )}
                </th>
              )
            })}
          </tr>
        ))}
        </thead>
        <tbody>
        {table.getRowModel().rows.map(row => {
          return (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => {
                return (
                  <td key={cell.id} style={{...cell?.column?.columnDef?.meta?.style}}>
                    {flexRender(
                      cell.column.columnDef.cell,
                      cell.getContext()
                    )}
                  </td>
                )
              })}
            </tr>
          )
        })}
        </tbody>
      </table>
      <div className="h-2"/>
      { !opts.hidePagination &&
        <div className="table-pagination">
          <div className={`navigate ${!table.getCanPreviousPage() ? 'disabled' : ''}`} onClick={() => table.getCanPreviousPage() && table.setPageIndex(0)}>
            {'First'}
          </div>

          <div className='divider'></div>

          {generatePageNumbers().map((pageNumber) => (
            <React.Fragment key={pageNumber}>
              <div
                onClick={() => table.getState().pagination.pageIndex + 1 !== pageNumber && table.setPageIndex(pageNumber - 1)}
                className={table.getState().pagination.pageIndex + 1 === pageNumber ? 'navigate active disabled' : 'navigate'}
              >
              {pageNumber}
            </div>
              <div className="divider"></div>
            </React.Fragment>
          ))}

          <div className={`navigate ${!table.getCanNextPage() ? 'disabled' : ''}`} onClick={() => table.getCanNextPage() && table.setPageIndex(table.getPageCount() - 1)}>
            {'Last'}
          </div>
        </div>
      }

    </div>
  )
}
export default memo(Table);
